const createGatsbyBrowserHooks = (initCookieRevokeContrast) => {
  let cleanupCookieRevokeContrast

  const startCookieRevokeContrast = () => {
    cleanupCookieRevokeContrast?.()
    cleanupCookieRevokeContrast = initCookieRevokeContrast()
  }

  return {
    onClientEntry: startCookieRevokeContrast,
    onRouteUpdate: startCookieRevokeContrast,
  }
}

module.exports = { createGatsbyBrowserHooks }
